'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var PeerId = require('peer-id');

var multiaddr = require('multiaddr');

var withIs = require('class-is');

var errCode = require('err-code');

var Status = require('./status');

function validateArgs(localAddr, localPeer, remotePeer, newStream, close, getStreams, stat) {
  if (localAddr && !multiaddr.isMultiaddr(localAddr)) {
    throw errCode(new Error('localAddr must be an instance of multiaddr'), 'ERR_INVALID_PARAMETERS');
  }

  if (!PeerId.isPeerId(localPeer)) {
    throw errCode(new Error('localPeer must be an instance of peer-id'), 'ERR_INVALID_PARAMETERS');
  }

  if (!PeerId.isPeerId(remotePeer)) {
    throw errCode(new Error('remotePeer must be an instance of peer-id'), 'ERR_INVALID_PARAMETERS');
  }

  if (typeof newStream !== 'function') {
    throw errCode(new Error('new stream must be a function'), 'ERR_INVALID_PARAMETERS');
  }

  if (typeof close !== 'function') {
    throw errCode(new Error('close must be a function'), 'ERR_INVALID_PARAMETERS');
  }

  if (typeof getStreams !== 'function') {
    throw errCode(new Error('getStreams must be a function'), 'ERR_INVALID_PARAMETERS');
  }

  if (!stat) {
    throw errCode(new Error('connection metadata object must be provided'), 'ERR_INVALID_PARAMETERS');
  }

  if (stat.direction !== 'inbound' && stat.direction !== 'outbound') {
    throw errCode(new Error('direction must be "inbound" or "outbound"'), 'ERR_INVALID_PARAMETERS');
  }

  if (!stat.timeline) {
    throw errCode(new Error('connection timeline object must be provided in the stat object'), 'ERR_INVALID_PARAMETERS');
  }

  if (!stat.timeline.open) {
    throw errCode(new Error('connection open timestamp must be provided'), 'ERR_INVALID_PARAMETERS');
  }

  if (!stat.timeline.upgraded) {
    throw errCode(new Error('connection upgraded timestamp must be provided'), 'ERR_INVALID_PARAMETERS');
  }
}
/**
 * An implementation of the js-libp2p connection.
 * Any libp2p transport should use an upgrader to return this connection.
 */


var Connection = /*#__PURE__*/function () {
  /**
   * Creates an instance of Connection.
   * @param {object} properties properties of the connection.
   * @param {multiaddr} [properties.localAddr] local multiaddr of the connection if known.
   * @param {multiaddr} [properties.remoteAddr] remote multiaddr of the connection.
   * @param {PeerId} properties.localPeer local peer-id.
   * @param {PeerId} properties.remotePeer remote peer-id.
   * @param {function} properties.newStream new stream muxer function.
   * @param {function} properties.close close raw connection function.
   * @param {function} properties.getStreams get streams from muxer function.
   * @param {object} properties.stat metadata of the connection.
   * @param {string} properties.stat.direction connection establishment direction ("inbound" or "outbound").
   * @param {object} properties.stat.timeline connection relevant events timestamp.
   * @param {string} properties.stat.timeline.open connection opening timestamp.
   * @param {string} properties.stat.timeline.upgraded connection upgraded timestamp.
   * @param {string} [properties.stat.multiplexer] connection multiplexing identifier.
   * @param {string} [properties.stat.encryption] connection encryption method identifier.
   */
  function Connection(_ref) {
    var localAddr = _ref.localAddr,
        remoteAddr = _ref.remoteAddr,
        localPeer = _ref.localPeer,
        remotePeer = _ref.remotePeer,
        newStream = _ref.newStream,
        close = _ref.close,
        getStreams = _ref.getStreams,
        stat = _ref.stat;

    _classCallCheck(this, Connection);

    validateArgs(localAddr, localPeer, remotePeer, newStream, close, getStreams, stat);
    /**
     * Connection identifier.
     */

    this.id = parseInt(Math.random() * 1e9).toString(36) + Date.now();
    /**
     * Observed multiaddr of the local peer
     */

    this.localAddr = localAddr;
    /**
     * Observed multiaddr of the remote peer
     */

    this.remoteAddr = remoteAddr;
    /**
     * Local peer id.
     */

    this.localPeer = localPeer;
    /**
     * Remote peer id.
     */

    this.remotePeer = remotePeer;
    /**
     * Connection metadata.
     */

    this._stat = _objectSpread(_objectSpread({}, stat), {}, {
      status: Status.OPEN
    });
    /**
     * Reference to the new stream function of the multiplexer
     */

    this._newStream = newStream;
    /**
     * Reference to the close function of the raw connection
     */

    this._close = close;
    /**
     * Reference to the getStreams function of the muxer
     */

    this._getStreams = getStreams;
    /**
     * Connection streams registry
     */

    this.registry = new Map();
    /**
     * User provided tags
     */

    this.tags = [];
  }
  /**
   * Get connection metadata
   * @return {Object}
   */


  _createClass(Connection, [{
    key: "stat",
    get: function get() {
      return this._stat;
    }
    /**
     * Get all the streams of the muxer.
     * @return {Array<*>}
     */

  }, {
    key: "streams",
    get: function get() {
      return this._getStreams();
    }
    /**
     * Create a new stream from this connection
     * @param {string[]} protocols intended protocol for the stream
     * @return {Promise<object>} with muxed+multistream-selected stream and selected protocol
     */

  }, {
    key: "newStream",
    value: function () {
      var _newStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(protocols) {
        var _yield$this$_newStrea, stream, protocol;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.stat.status === Status.CLOSING)) {
                  _context.next = 2;
                  break;
                }

                throw errCode(new Error('the connection is being closed'), 'ERR_CONNECTION_BEING_CLOSED');

              case 2:
                if (!(this.stat.status === Status.CLOSED)) {
                  _context.next = 4;
                  break;
                }

                throw errCode(new Error('the connection is closed'), 'ERR_CONNECTION_CLOSED');

              case 4:
                if (!Array.isArray(protocols)) protocols = [protocols];
                _context.next = 7;
                return this._newStream(protocols);

              case 7:
                _yield$this$_newStrea = _context.sent;
                stream = _yield$this$_newStrea.stream;
                protocol = _yield$this$_newStrea.protocol;
                this.addStream(stream, {
                  protocol: protocol
                });
                return _context.abrupt("return", {
                  stream: stream,
                  protocol: protocol
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function newStream(_x) {
        return _newStream.apply(this, arguments);
      }

      return newStream;
    }()
    /**
     * Add a stream when it is opened to the registry.
     * @param {*} muxedStream a muxed stream
     * @param {object} properties the stream properties to be registered
     * @param {string} properties.protocol the protocol used by the stream
     * @param {object} properties.metadata metadata of the stream
     * @return {void}
     */

  }, {
    key: "addStream",
    value: function addStream(muxedStream, _ref2) {
      var protocol = _ref2.protocol,
          _ref2$metadata = _ref2.metadata,
          metadata = _ref2$metadata === void 0 ? {} : _ref2$metadata;
      // Add metadata for the stream
      this.registry.set(muxedStream.id, _objectSpread({
        protocol: protocol
      }, metadata));
    }
    /**
     * Remove stream registry after it is closed.
     * @param {string} id identifier of the stream
     */

  }, {
    key: "removeStream",
    value: function removeStream(id) {
      this.registry.delete(id);
    }
    /**
     * Close the connection.
     * @return {Promise}
     */

  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.stat.status === Status.CLOSED)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (!this._closing) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", this._closing);

              case 4:
                this.stat.status = Status.CLOSING; // Close raw connection

                _context2.next = 7;
                return this._close();

              case 7:
                this._closing = _context2.sent;
                this._stat.timeline.close = Date.now();
                this.stat.status = Status.CLOSED;

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }]);

  return Connection;
}();

module.exports = withIs(Connection, {
  className: 'Connection',
  symbolName: '@libp2p/interface-connection/connection'
});